import { render, staticRenderFns } from "./tm-past-orders.vue?vue&type=template&id=25b98f20&scoped=true&"
import script from "./tm-past-orders.vue?vue&type=script&lang=ts&"
export * from "./tm-past-orders.vue?vue&type=script&lang=ts&"
import style0 from "./tm-past-orders.vue?vue&type=style&index=0&id=25b98f20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b98f20",
  null
  
)

export default component.exports